import { createSlice } from '@reduxjs/toolkit';
import { IToast } from '~/utils/interface/toast';
import { RootState } from '~/utils/redux/store';

interface toastState {
  toasts: IToast[];
}

const initialState: toastState = {
  toasts: [],
};

const toastSlice = createSlice({
  name: 'toastSlice',
  initialState,
  reducers: {
    addToast(state, action) {
      state.toasts.push(action.payload);
    },
    clearToasts(state) {
      state.toasts = [];
    },
    updateToasts(state, action) {
      state.toasts = action.payload;
    },
    removeToast(state, action) {
      const messageId = action.payload;
      state.toasts = state.toasts.filter((toast) => toast.id !== messageId);
    },
  },
});

// Actions
export const toastActions = toastSlice.actions;

// Selectors
export const selectToasts = (state: RootState) => state.toastState.toasts;

// Reducer
const toastReducer = toastSlice.reducer;
export default toastReducer;
